import React from "react";

export default function SareeIcon({ className = "w-5 h-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M12 2.5a1.6 1.6 0 0 1 1.6 1.6c0 .9-.7 1.6-1.6 1.6" />
      <path d="M12 5.7 3.2 10.4a1.1 1.1 0 0 0 .55 2.05h16.5a1.1 1.1 0 0 0 .55-2.05L12 5.7z" />
      <path d="M5.5 12.5v7" />
      <path d="M18.5 12.5v7" />
      <path d="M5.5 15.2h13" />
      <path d="M5.5 18.4l2.2-1.6 2.1 1.6 2.2-1.6 2.1 1.6 2.2-1.6 2.2 1.6" />
    </svg>
  );
}
